import { forwardRef } from "react";
import { TextField, InputAdornment, Popover, Box } from "@mui/material";
import { HexColorPicker } from "react-colorful";
import { RxCross1 } from "react-icons/rx";


import { ColorPickerInputProps } from "./types";
import { useColorPickerInputController } from "./controller";

export const ColorPickerInput = forwardRef<HTMLInputElement, ColorPickerInputProps>(
  ({ name, label, error, helperText, required, ...rest}, ref) => {
    const {
      color,
      anchorEl,
      inputValue,
      handleOpen,
      handleClose,
      handleColorChange,
      handleInputChange,
      handleBlur,
      handleClearColor,
    } = useColorPickerInputController({ ...rest });

    return (
      <>
        <TextField
          name={name}
          value={inputValue || ""}
          onChange={handleInputChange}
          onBlur={handleBlur}
          label={`${label}${required ? " *" : ""}`}
          error={!!error}
          helperText={helperText}
          fullWidth
          variant="outlined"
          placeholder="#ffffff"
          inputRef={ref}
          sx={{
            "& .MuiInputBase-root": {
              height: "45px",
            },
            "& .MuiInputBase-input": {
              fontSize: 14,
              padding: "8px 12px",
            },
          }}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      backgroundColor: color || "transparent",
                      cursor: "pointer",
                      border: color ?? "1px solid rgba(0, 0, 0, 0.6)",
                    }}
                    onClick={handleOpen}
                  />

                  <Box
                    sx={{
                      borderRadius: "50%",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                      marginLeft: 1,
                      alignItems: "center",
                      justifyContent: "center",
                      display: color ? "flex" : "none",
                    }}
                    onClick={handleClearColor}
                  >
                    <RxCross1 />
                  </Box>
                </InputAdornment>
              ),
            },
          }}
        />

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Box sx={{ p: 2 }}>
            <HexColorPicker color={color || "#000000"} onChange={handleColorChange} />
          </Box>
        </Popover>
      </>
    );
  }
);

ColorPickerInput.displayName = "ColorPickerInput";
